.surface {
    display: flex;
    flex-direction: column;
    background-color: var(--bi-color-surface);
    color: var(--bi-color-text);
}

.container {
    display: flex;
    align-self: center;
    justify-content: space-between;
    width: 100%;
    font: var(--bi-font-body-medium);
    max-width: calc(1128px + var(--bi-scale-4x) * 2);
    padding: var(--bi-scale-4x);
    gap: var(--bi-scale-2x);

    @media (width < 768px), (width >= 1024px) {
        font: var(--bi-font-body-large);
    }

    @media (width < 1024px) {
        padding: var(--bi-scale-4x) var(--bi-scale-6x);
    }

    @media (width < 768px) {
        padding: var(--bi-scale-8x) var(--bi-scale-4x);
    }

    .list {
        display: flex;
        flex: 1;
        gap: var(--bi-scale-6x);

        @media (width < 1024px) {
            gap: var(--bi-scale-4x);
        }

        @media (width < 768px) {
            flex-direction: column;
            gap: var(--bi-scale-2x);
        }
    }

    /* The design system's button doesn't shrink, so a long label would push past the screen edge instead of wrapping. */
    > :global(.bi-button) {
        margin: auto 0;
        flex-shrink: 1;
        min-width: min-content;
    }
}

.listItem {
    display: flex;
    align-items: flex-start;
    gap: var(--bi-scale-3x);

    &:nth-last-child(1 of .listItem) {
        flex: 1;

        .value {
            white-space: initial;
        }
    }

    svg {
        flex-shrink: 0;
        margin-top: var(--bi-scale-4x);
        font-size: var(--bi-icon-large);
        @media (width < 1024px) {
            font-size: var(--bi-icon-medium);
        }
        @media (width < 768px) {
            margin: 0;
        }
    }

    > div {
        padding: var(--bi-scale-2x) 0;
        @media (width < 768px) {
            padding: 0;
        }

        > .label {
            font-weight: var(--bi-font-weight-bold);
            @media (width < 768px) {
                display: none;
            }
        }
        > .value {
            @media (width >= 768px) {
                white-space: nowrap;
            }
        }
    }
}

.divider {
    border-right: 1px solid var(--bi-primary-90);
    opacity: 0.15;
    height: var(--bi-scale-6x);
    margin: var(--bi-scale-4x) 0;

    @media (width < 768px) {
        display: none;
    }
}
